import { render, staticRenderFns } from "./BreadcrumbContainer.vue?vue&type=template&id=66b699fe"
import script from "./BreadcrumbContainer.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbContainer.vue?vue&type=script&lang=ts"
import style0 from "./BreadcrumbContainer.vue?vue&type=style&index=0&id=66b699fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports